import React from "react";
import { Navigate, useParams } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

/** Clients only use Home; studio routes stay admin-only. */
export default function ClientHomeOnly({ children }) {
  const { user } = useAuth();
  const { clientSlug } = useParams();
  if (user?.role === "client") {
    return <Navigate to={`/${clientSlug}`} replace />;
  }
  return children;
}
